import type { CSSProperties } from 'react'
import React, { useState, useEffect, useRef } from 'react'
import { Modal } from 'antd'
import EasyIcon from './EasyIcon'
import { useDomSize } from 'src/hooks'
import 'src/styles/components/common/ellipsisTextView.less'

const EllipsisTextView = (props: {
  text: string,
  renderIcon?: React.ReactNode,
  className?: string,
  style?: CSSProperties
}) => {
  const el = useRef<HTMLDivElement>(null)

  const domSize = useDomSize(el)

  const [isFlow, setIsFlow] = useState(false)
  useEffect(() => {
    el.current && setIsFlow(el.current.clientWidth < el.current.scrollWidth)
  }, [props.text, domSize.clientWidth])

  const handleViewDetail = () => {
    Modal.info({
      icon: null,
      content: <div dangerouslySetInnerHTML={{ __html: props.text }} />,
      okText: '确定',
    })
  }

  return (
    <div className={`ellipsis-text ${props.className}`} style={props.style}>
      <div ref={el} className='ellipsis-text__detect'>{props.text}</div>
      <div title={props.text} className='ellipsis-text__text'>{props.text}</div>
      {
        isFlow
          ? (
            props.renderIcon ?? (
              <EasyIcon
                type='FileSearchOutlined'
                onClick={handleViewDetail}
                className='ellipsis-text__view'
              />
            )
          )
          : null
      }
    </div>
  )
}

export default EllipsisTextView